const colorMap = new Map([
    ['Rust', ["#b7410e", false]],
    ['Multicolor', ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", true]],
    ['Peach', ["#ffdab9", false]],
    ['Golden', ["#ffd900", false]],
    ['Off-White', ["#f5f5f5", false]],
    ['Cream', ["#fffdd0", false]],
    ['Sky Blue', ["#87CEEB", false]],
    ['Navy Blue', ["#000080", false]],
    ['Light Blue', ["#ADD8E6", false]],
    ['Olive Green', ["#556B2F", false]],
    ['Light Green', ["#90EE90", false]],
    ['Dark Grey', ["#A9A9A9", false]],
    ['Dark Blue', ["#00008B", false]],
    ['Jet Black', ["#000000", false]],
    ['Bright White', ["#FFFFFF", false]],
    ['Light Grey', ["#D3D3D3", false]],
    ['Wine', ["#722F37", false]],
    ['Teal Blue', ["#008080", false]],
  ['Royal Blue', ["#4169E1", false]],
  ['Indigo Blue', ["#4B0082", false]],
  ['Mid Blue', ["#0000CD", false]],
  ['Peacock Blue', ["#006994", false]],
  ['Deep Blue', ["#000080", false]],
  ['Aqua Blue', ["#00FFFF", false]],
  ['Ice Blue', ["#BCE6E6", false]],
  ['Night Blue', ["#191970", false]],
  ['Denim Blue', ["#1560BD", false]],
  ['Turquoise Blue', ["#40E0D0", false]],
  ['Brick Red', ["#B22222", false]],
  ['Light Red', ["#FF6961", false]],
  ['Dark Red', ["#8B0000", false]],
  ['Bright Red', ["#FF0000", false]],
  ['Carrot red', ["#FF4500", false]],
  ['Burn Red', ["#9A3334", false]],
  ['Cardinal Red', ["#C41E3A", false]],
  ['Oxblood Red', ["#800020", false]],
  ['Rio Red', ["#DA2C43", false]],
  ['Rose Red', ["#FF033E", false]],
  ['Rumba Red', ["#C76E70", false]],
  ['Spice Red', ["#A23C3C", false]],
  ['Tango Red', ["#E25822", false]],
  ['Deep Red', ["#8B0000", false]],
  ['Mustard Yellow', ["#FFDB58", false]],
  ['Light Yellow', ["#FFFFE0", false]],
  ['Lemon Yellow', ["#FFF44F", false]],
  ['Mellow Yellow', ["#F8DE7E", false]],
  ['Bright Yellow', ["#FFFF00", false]],
  ['Golden Yellow', ["#FFD700", false]],
  // ['Honey Yellow', ["#E0Cfalse", false]],
  ['Chrome Yellow', ["#FFA700", false]],
  ['Corn Yellow', ["#FBEC5D", false]],
  ['Musturd Yellow', ["#FFDB58", false]],
  ['Pale Yellow', ["#EEE8AA", false]],
  ['Pastel Yellow', ["#FDFD96", false]],
  ['Taffy Yellow', ["#F8DE7E", false]],
  ['Dark Green', ["#006400", false]],
  ['Light Pink', ["#FFB6C1", false]],
  ['Onion Pink', ["#F5B9F5", false]],
  ['Island Pink', ["#FFD1DC", false]],
  ['Lilac Pink', ["#FFC0CB", false]],
  ['Rose Pink', ["#FF66CC", false]],
  ['Coral Pink', ["#FF7F50", false]],
  ['Dusty Pink', ["#D8BFD8", false]],
  ['Send Pink', ["#FF91A4", false]],
  ['Blossom Pink', ["#FFC3A0", false]],
  ['Delicacy Pink', ["#FEC3AC", false]],
  ['Flamingo Pink', ["#FC8EAC", false]],
  ['Pastel Pink', ["#FFD1BB", false]],
  ['Baby Pink', ["#FFC0CB", false]],
  ['Pastel Purple', ["#B39EB5", false]],
  ['Dark Purple', ["#800080", false]],
  ['Beige', ["#F5F5DC", false]],
  ['Light Purple', ["#E6E6FA", false]],
  ['Cloud Cream', ["#FFF8E7", false]],
  ['Custard Cream', ["#FFF0C1", false]],
  ['Dark Cream', ["#EEE8AA", false]],
  ['Dawn Cream', ["#FFFAF0", false]],
  ['Fawn Cream', ["#E5AA70", false]],
  ['Italian Cream', ["#F6ECD8", false]],
  ['Light Orange', ["#FFD68F", false]],
  ['Apricot Orange', ["#FDD5B1", false]],
  ['Bright Orange', ["#FF8C00", false]],
  ['Burnt Orange', ["#FF4500", false]],
  ['Coral Orange', ["#FF7F50", false]],
  ['Golden Orange', ["#FFD700", false]],
  ['Apricot Orange', ["#FBCEB1", false]],
  ['Dark Olive', ["#556B2F", false]],
  ['Olive Brown', ["#806517", false]],
  ['Light Olive', ["#AAB300", false]],
  ['Olive Grey', ["#B5B35C", false]],
  ['Branch Olive', ["#5F6527", false]],
  ['Dark Olive Green', ["#556B2F", false]],
  ['Deep Olive Green', ["#556B2F", false]],
  ['Dusty Olive', ["#8A8662", false]],
  ['Olive Melange', ["#6B6C4A", false]],
  ['Dark Maroon', ["#800000", false]],
  ['Maroon gold', ["#B03060", false]],
  ['Silver Grey', ["#C0C0C0", false]],
  ['Lime Green', ["#00FF00", false]],
  ['State Gray', ["#808080", false]],
  ['Teal Green', ["#008080",false]],
  ['Dusty Teal', ["#4e5d4e",false]],
  ['Teal Black', ["#003838",false]],
  ['Teal Grey', ["#69838d",false]],
  ['Midnight Navy', ["#000080", false]],
    ['Grey Melange', ["#808080", false]],
  ['Charcoal Grey', ["#36454F", false]],
  ['Ercus Melange', ["#B5B5B5", false]],
  ['Air Force Blue', ["#5D8AA8", false]],
  ['Aquamarine Blue', ["#7FFFD4", false]],
  ['Carrot Brown', ["#ED9121", false]],
  ['Colonial Blue', ["#002F6C", false]],
  ['Cornet Blue', ["#6495ED", false]],
  ['Deep Wine', ["#8B0000", false]],
  ['Bottle Green', ["#092E20", false]],
  ]);
  window.onWizzyScriptLoaded = function () {
  
     var isFirstLoad = true;
    
        window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, function (payload) {
         if(isFirstLoad && isOnCollectionPage()){
           isFirstLoad = false;
           payload.filters.sort = [ {field: 'product_new_arrivals_date_custom:datetime', order: 'desc'} , {field: 'product_wizzy-best-selling_sortOrder:float', order: 'asc'} ]
           if(window.wizzyConfig?.pageStore?.selectedSortMethod)   window.wizzyConfig.pageStore.selectedSortMethod = {field: 'product_new_arrivals_date_custom:datetime', order: 'desc'};
         }
        return payload;
      });
  
  
    // function isOnCollectionPage(){
    //   return window.location.href.split("/").includes("collections")
    // };
  
      window.replaceWizzyTemplate("wizzy-search-results");
      window.replaceWizzyTemplate("wizzy-search-results-product");
      window.replaceWizzyTemplate("wizzy-search-wrapper");
      window.replaceWizzyTemplate("wizzy-search-summary");
  
      if (window.innerWidth > 768) {
          window.replaceWizzyTemplate("wizzy-autocomplete-topproducts");
  
      } else {
  
          window.wizzyConfig.search.configs.facets.leftFacets.defaultCollapsed = true;
  
  
          let newDiv = document.getElementById('wizzy-autocomplete-topproducts-mobile' + "-new");
          let oldDiv = document.getElementById('wizzy-autocomplete-topproducts');
  
          newDiv = newDiv.text;
          oldDiv.text = newDiv;
  
  
          var closeButton = document.getElementById('closeButton');
  
          closeButton.addEventListener('click', function () {
  
              var wizzyIcon = document.querySelector('.wizzy-icon');
              var inputBox = document.querySelector('#wizzy-search-input');
  
              if (wizzyIcon) {
                  wizzyIcon.click();
                  inputBox.click();
              }
  
              var wizzySearchIcon = document.querySelector('.wizzy-search-form');
              wizzySearchIcon.style.display = 'block';
  
  
          });
  
          var closeButton = document.getElementById('wizzyDisplayControl');
  
          closeButton.addEventListener('click', function () {
  
              var wizzySearchIcon = document.querySelector('.wizzy-search-form');
              wizzySearchIcon.style.display = 'none';
          });
  
  
      }
  
  
  
  
  
      function preloadImage(url) {
          var img = new Image();
          img.src = url;
      }
  
  
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.BEFORE_INIT, //PRODUCTS_RESULTS_RENDERED
          function (payload) {
              payload.filters = {
                  configs: {
                      keepOpenedInMobileAfterApply: true
                  }
              }
              payload.common.lazyDOMConfig.searchInputIdentifiers.push({
                  dom: "#wizzySearch", // #inputID or .InputClass
                  type: "search", // Type of Input Search or Text
              });
  
              return payload;
          }
      );
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, //PRODUCTS_RESULTS_RENDERED
          function (payload) {
              let allFacets = payload.response.payload.facets;
              allFacets.forEach((obj) => {
                  if (obj.label == "Discount") {
                      let disArray = obj.data;
                      const sortedObj = disArray.sort((a, b) => {
                          const aLabel = a.label.toUpperCase();
                          const bLabel = b.label.toUpperCase();
  
                          if (aLabel.charAt(0) === 'N' && bLabel.charAt(0) !== 'N') {
                              return -1; // 'a' comes first
                          } else if (aLabel.charAt(0) !== 'N' && bLabel.charAt(0) === 'N') {
                              return 1; // 'b' comes first
                          }
  
                          if (aLabel.charAt(1) === 'U' && bLabel.charAt(1) !== 'U') {
                              return -1; // 'a' comes first
                          } else if (aLabel.charAt(1) !== 'U' && bLabel.charAt(1) === 'U') {
                              return 1; // 'b' comes first
                          }
  
                          return aLabel.localeCompare(bLabel);
                      });
  
                  }
  
              })
              return payload;
          });
      function handleResize() {
  
          var element = document.getElementById('wizzySearch');
  
          var width = element.getBoundingClientRect().width;
          var autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
  
          document.documentElement.style.setProperty('--custom-width', width + 'px');
      }
      var wizzySearchElement = document.getElementById('wizzySearch');
  
      wizzySearchElement.addEventListener('input', function () {
          handleResize();
      });
  
      window.addEventListener('resize', handleResize);
  
      if (window.innerWidth > 768) {
          var observer = new MutationObserver(function (mutations) {
              mutations.forEach(function (mutationRecord) {
  
                  if (mutationRecord != undefined && mutationRecord.target.classList && mutationRecord.target.classList.contains("invisible")) {
                      document.body.classList.remove("wizzy-scrollbar-fix");
                  } else {
  
                      document.body.classList.add("wizzy-scrollbar-fix");
                      var wizzyIcon = document.querySelector('#wizzySearch');
  
                      if (wizzyIcon) {
  
                          wizzyIcon.click();
                      }
  
                  }
  
  
              });
          });
  
          var target = document.getElementById('wizzyId');
          observer.observe(target, {
              attributes: true,
              attributeFilter: ['class']
          });
  
  
      }
  
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
          function (payload) {
              const listItemElements = document.querySelectorAll('li.wizzy-selected-facet-list-item');
              const facetKeySet = new Set();
  
              listItemElements.forEach((liElement) => {
                  const facetKey = liElement.getAttribute('data-facetkey');
                  facetKeySet.add(facetKey);
              });
  
              const uniqueFacetKeyCount = facetKeySet.size;
              const linkElement = document.querySelector('a.wizzy-filters-mobile-entry');
              linkElement.innerText = "Filters " + '(' + uniqueFacetKeyCount + ')';
          });
  
  
  
  
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
          function (payload) {
              let sortBy = payload.filters.sort
              sortBy.forEach(obj => {
                  if (obj.field == 'product_new_arrivals_date_custom')
                      obj.field = 'product_new_arrivals_date_custom:datetime';
              });
              return payload;
          });
  
  
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
          function (payload) {
  
              var wizzyIcon = document.querySelector('.wizzy-search-back');
  
              if (wizzyIcon) {
                  wizzyIcon.click();
              }
  
              var wizzySearchIcon = document.querySelector('.wizzy-search-form');
              wizzySearchIcon.style.display = 'none';
  
              var colProd = document.querySelector('.featured-category-wrapper.text-body.bg-page');
              if (colProd) {
                  colProd.style.display = 'none';
              }
              var wizzyDisplay = document.querySelector('#wizzyDisplay');
              if (wizzyDisplay) {
                  wizzyDisplay.style.display = 'none';
              }
  
              const wizzyElement = document.getElementById('wizzyId');
  
  
              wizzyElement.classList.add('invisible');
              wizzyElement.classList.add('h-0');
              wizzyElement.classList.add('opacity-0');
  
              return payload;
          });
  
      window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (payload) {
  
          window.wizzyConfig.pageStore.searchInputValue = payload.q;
          return payload;
      });
  
      window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function (payload) {
  
  
          var element = document.querySelector('[data-aid="collection-title"]');
          if (element && payload.response.payload.result) {
  
  
              var collectionTitle = element.textContent;
  
  
              setTimeout(function () {
                  var element = document.querySelector('.wizzy-search-filters-list-top');
                  element.textContent = "Home / ";
  
  
                  var element = document.querySelector('.wizzy-search-filters-list-top');
                  var spanElement = document.createElement('span');
                  spanElement.textContent = collectionTitle;
                  element.appendChild(spanElement);
  
  
                  var spanElement = document.createElement('span');
                  spanElement.setAttribute('id', 'wizzyProductCount');
                  spanElement.textContent = " (" + payload.response.payload.total + " Products)";
                  element.appendChild(spanElement);
                  if (window?.baCurr) {
                      window?.baCurr?.refreshConversion();
                  }
              }, 250); // Delay of 2000 milliseconds (2 seconds)
  
          }
  
          if (payload.api === 'search' || payload.api === "filter") {
              var facets = payload.response.payload.facets;
             
              facets.forEach((facet) => {
               
                  if (facet.key === "product_color_magento") {
                      const facetItem = facet.data;
  
  
                      facetItem.forEach((item) => {
  
  
                        let color=findHaxCode(item.key)
                          item.isSwatch = true;
                          item.isURLSwatch = color[1];
                          item.isVisualSwatch = true;
                          item.swatchValue =color[0];
                          item.data = {
                              value: item.key,
                              swatch: {
                                  type: 'visual',
                                  value: color[0]
                              }
                          }
  
                      })
                  }
              })
  
          }
  
          return payload;
      });
  
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
          function (payload) {
              if (window.innerWidth < 768) {
                  var elements = document.getElementsByClassName("wizzy-filters-facet-block");
                  for (var i = 0; i < elements.length; i++) {
                      var element = elements[i];
                      element.addEventListener("click", function () {
                          this.classList.toggle("collapsed");
                      });
                  }
  
              }
  
  
              var filterClick = document.querySelectorAll('.wizzy-filters-facet-block');
              filterClick.forEach(function (element) {
                  element.addEventListener('click', function (e) {
  
                      var divList = document.querySelectorAll('.wizzy-filters-facet-block');
                      divList.forEach(function (element) {
                          if (element.classList.toString() == e.target.parentElement.parentNode.classList.toString()) {
                          } else {
                              element.classList.add('collapsed')
  
                          }
  
                      })
  
                  });
              });
  
  
              return payload;
          });
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
          function (data) {
              let facets = data.response.payload.facets;
              for (let i = 0; i < facets.length; i++) {
                  if (facets[i].key == "product_Size") {
  
                      let sizes = facets[i].data;
                      let numbers = [];
                      let letters = [];
  
                      for (let i = 0; i < sizes.length; i++) {
                          let individualSize = sizes[i].key.length;
                          if (sizes[i].key[individualSize - 1] >= '0' && sizes[i].key[individualSize - 1] <= '9') {
                              numbers.push(sizes[i]);
                          }
                      }
                      numbers.sort(function (a, b) {
                          if (a.key < b.key) {
                              return -1;
                          } else if (a.key > b.key) {
                              return 1;
                          } else {
                              return 0;
                          }
                      });
  
                      let newArray = new Array();
                      let temp = ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
                      for (let j = 0; j < temp.length; j++) {
  
                          for (let k = 0; k < sizes.length; k++) {
                              if (sizes[k].key == temp[j])
                                  newArray.push(sizes[k]);
                          }
                      }
  
                      for (let index = 0; index < numbers.length; index++) {
                          newArray.push(numbers[index]);
                      }
  
                      facets[i].data = newArray;
  
                  }
              }
  
  
              return data;
  
          });
  
      window.wizzyConfig.events.registerEvent(
          window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
          function (data) {
              data.forEach((product) => {
                  product.mainImage = product.images[0];
                  product.hoverImage = product.images.length > 1 ? product.images[1] : product.images[0];
  
                  if (product.price) {
                      let varValue = product.price;
                      let ans = "";
                      for (let i = 0; i < varValue.length && varValue[i] !== '.'; i++) {
                          ans += varValue[i];
                      }
                      product.price = ans;
                  }
                  if (product.sellingPrice) {
                      let varValue = product.sellingPrice;
                      let ans = "";
                      for (let i = 0; i < varValue.length && varValue[i] !== '.'; i++) {
                          ans += varValue[i];
                      }
                      product.sellingPrice = ans;
                  }
  
                  let attributes = product.attributes;
  
                  let newArrival = 0;
                  attributes.forEach((attribute) => {
                      if (attribute.id == "product_badges_value_badges") {
  
                          newArrival = 1;
  
                      }
  
                  });
  
                  if (isOnCollectionPage()) {
                      // product.url = product.url + "?source=collection"
                      // product.url = window.location.href + "/" + product.url.replace(window.location.origin + '/', '');
                      let p_url = product.url.split('/products');
                      if (p_url.length >= 2) {
                          product.url = window.location.pathname + '/products' + p_url[1]
                      }
                  }
  
                  product.newArrival = newArrival;
              });
  
              //console.log(data);
              setTimeout(() => {
                  if (window?.baCurr) {
                      window?.baCurr?.refreshConversion();
                  }
              }, 500)
              return data;
          });
  }
  
  function isOnCollectionPage() {
      if (window.location.pathname.includes("collection") && !window.location.pathname.includes("products")) {
          return true;
      }
      return false;
  }
  
  
  
  function findHaxCode(key) {
  
    if (colorMap.has(key)) {
      return colorMap.get(key);
    } else {
      return [key, false];
    }
  }
  
  
  window.replaceWizzyTemplate = (ele) => {
      let newDiv = document.getElementById(ele + "-new");
      let oldDiv = document.getElementById(ele);
  
      newDiv = newDiv.text;
      oldDiv.text = newDiv;
  };